import React, { useEffect, useState, lazy, Suspense } from "react";
import googleImg from "../static/img/google.png";
import logoMobile from "../static/img/logo-mobile.png";
import { useTranslation } from "react-i18next";
import UserService from "../../../class/User/UserService.js";
import AuthService from "../../../class/services/AuthService.js";

import InfoScreenManager from "./info_screen.js";

/* import { Toaster } from 'react-hot-toast'; */

// Lazy load the CompleteRegistrationModal
const CompleteRegistrationModal = lazy(
    () => import("../modal/modal_register2.js"),
);

function ModalRegister({ show, onClose, onOpenLoginModal, setIsLogged }) {
    const { t } = useTranslation();
    const [animate, setAnimate] = useState(false);
    const [visible, setVisible] = useState(show);
    const [showPassword, setShowPassword] = useState(false); // Для показу/приховування пароля
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Для підтвердження пароля
    const [showCompleteModal, setShowCompleteModal] = useState(false); // Для керування другим модальним вікном

    const [confirmPasswordError, setConfirmPasswordError] = useState(false);

    const [emailError, setEmailError] = useState(false);
    const [usernameError, setUsernameError] = useState(false);

    const [formData, setFormData] = useState({
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
    });

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Проста перевірка email
        return emailRegex.test(email);
    };

    useEffect(() => {
        if (show) {
            setVisible(true);
            setTimeout(() => setAnimate(true), 200);

            const savedData = JSON.parse(
                localStorage.getItem("register_form_data"),
            );
            if (savedData) setFormData(savedData);
        } else {
            setAnimate(false);
            setTimeout(() => setVisible(false), 300);
        }
    }, [show]);

    useEffect(() => {
        const isFormEmpty = Object.values(formData).every(
            (value) => value === "",
        );

        if (!isFormEmpty) {
            localStorage.setItem(
                "register_form_data",
                JSON.stringify(formData),
            );
        }
    }, [formData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => {
            const newFormData = { ...prevState, [name]: value };

            if (name === "confirmPassword") {
                setConfirmPasswordError(newFormData.password !== value);
            }

            if (name === "email") {
                setEmailError(!validateEmail(value));
            }

            return newFormData;
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const openCompleteModal = () => {
        // Закриваємо перше модальне вікно і відкриваємо друге

        const isEmailValid = validateEmail(formData.email);
        const doPasswordsMatch = formData.password === formData.confirmPassword;

        // Оновлюємо стани помилок
        setEmailError(!isEmailValid);
        setConfirmPasswordError(!doPasswordsMatch);

        if (isEmailValid && doPasswordsMatch) {
            // Якщо все валідно, відкриваємо друге модальне вікно
            setAnimate(false);
            setTimeout(() => {
                setVisible(false);
                setShowCompleteModal(true);
            }, 300);
        }
    };

    const closeCompleteModal = () => {
        // Закриваємо друге модальне вікно і не відкриваємо перше
        setShowCompleteModal(false);
        onClose(); // Закриваємо процес після закриття другого модального вікна
    };

    const closeFirstModal = () => {
        setAnimate(false);
        setTimeout(() => {
            setVisible(false);
            onClose(); // Закриваємо процес
        }, 300);
    };

    const handleLoginClick = () => {
        if (onOpenLoginModal) {
            onClose(); // Закриваємо модальне вікно реєстрації
            setTimeout(() => {
                onOpenLoginModal(); // Відкриваємо модальне вікно входу після затримки
            }, 300);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const doPasswordsMatch = formData.password === formData.confirmPassword;
        setConfirmPasswordError(!doPasswordsMatch);
        if (!doPasswordsMatch) return;

        const combinedData = {
            name: formData.username,
            password: formData.password,

            currency: [AuthService.getCustom("currency")],
            agent_id: [AuthService.getCustom("promoter_code")],
        };

        try {
            const response = await UserService.createUser(
                combinedData.email || combinedData.name + "@spqrlab.com",
                combinedData.password,
                combinedData.name,
                combinedData.lastname || "",
                combinedData.firstname || "",
                combinedData.document_type || "",
                combinedData.document_number || "",
                combinedData.mobile || "",
                combinedData.birthday || "",
                combinedData.currency,
                combinedData.agent_id,
            );

            // console.log("Registration Response:", response);

            if (response.status == true) {
                AuthService.setToken(response.user_auth_token);
                AuthService.setCustom("username", response.response.username);
                AuthService.setCustom("user_id", response.user_auth_token);
                setIsLogged(true);
                localStorage.removeItem("complete_registration_form");
                localStorage.removeItem("register_form_data");

                // Показываем bootstrap уведомление об успешной регистрации
                const alertDiv = document.createElement("div");
                alertDiv.className =
                    "alert alert-success alert-dismissible fade show position-fixed top-0 end-0 m-3";
                alertDiv.role = "alert";
                alertDiv.style.zIndex = 99999;
                alertDiv.innerHTML = `
              <strong>${t("Registration")}</strong> ${t("Registration_successful")}
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            `;
                document.body.appendChild(alertDiv);

                setTimeout(() => {
                    alertDiv.classList.remove("show");
                    alertDiv.classList.add("hide");
                    setTimeout(() => {
                        if (alertDiv.parentNode) {
                            alertDiv.parentNode.removeChild(alertDiv);
                        }
                    }, 500);
                }, 3000);
            } else {
                // Показываем bootstrap уведомление об ошибке регистрации
                const alertDiv = document.createElement("div");
                alertDiv.className =
                    "alert alert-danger alert-dismissible fade show position-fixed top-0 end-0 m-3";
                alertDiv.role = "alert";
                alertDiv.style.zIndex = 99999;
                alertDiv.innerHTML = `
            <strong>${t("Error_Registration")}</strong> ${response.message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            `;
                document.body.appendChild(alertDiv);

                setTimeout(() => {
                    alertDiv.classList.remove("show");
                    alertDiv.classList.add("hide");
                    setTimeout(() => {
                        if (alertDiv.parentNode) {
                            alertDiv.parentNode.removeChild(alertDiv);
                        }
                    }, 500);
                }, 3000);
            }
        } catch (error) {
            console.error(`${t("Error_creating_user")}:`, error);
        }
    };

    if (!visible && !showCompleteModal) return null; // Відображаємо, якщо хоча б одне модальне вікно відкрите

    return (
        <>
            {/* Перше модальне вікно */}
            {visible && (
                <div
                    className={`modal fade registration_modal ${animate ? "show" : ""}`}
                    id="registration_modal"
                    tabIndex="-1"
                    style={{ display: "block" }}
                    aria-modal={show ? "true" : "false"}
                    role="dialog"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3>
                                    <img
                                        src="/assets/img/logo-mobile.png"
                                        alt="Nome-sito"
                                    />{" "}
                                    {t("Sign_up")}
                                </h3>
                                <button
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={closeFirstModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <section className="forms">
                                    <div className="form signup">
                                        <div className="form-content">
                                            <form action="#">
                                                <div className="field input-field">
                                                    {/* <input
                            type="email"
                            placeholder={t('Email')}
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className={`input ${
                              emailError ? "input-error" : ""
                            }`}
                          /> */}

                                                    <input
                                                        type="username"
                                                        placeholder={t(
                                                            "Username",
                                                        )}
                                                        name="username"
                                                        value={
                                                            formData.username
                                                        }
                                                        onChange={(e) => {
                                                            // Only allow latin letters and numbers, no spaces or special chars
                                                            const value =
                                                                e.target.value.replace(
                                                                    /[^a-zA-Z0-9]/g,
                                                                    "",
                                                                );
                                                            setFormData(
                                                                (
                                                                    prevState,
                                                                ) => ({
                                                                    ...prevState,
                                                                    username:
                                                                        value,
                                                                }),
                                                            );
                                                            setUsernameError(
                                                                value === "",
                                                            );
                                                        }}
                                                        className={`input ${usernameError ? "input-error" : ""}`}
                                                    />
                                                </div>
                                                <div className="field input-field">
                                                    <input
                                                        type={
                                                            showPassword
                                                                ? "text"
                                                                : "password"
                                                        }
                                                        placeholder={t(
                                                            "Create_password",
                                                        )}
                                                        className="password"
                                                        name="password"
                                                        value={
                                                            formData.password
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                    <i
                                                        className={`bx ${
                                                            showPassword
                                                                ? "bx-show"
                                                                : "bx-hide"
                                                        } eye-icon`}
                                                        onClick={
                                                            togglePasswordVisibility
                                                        }
                                                    ></i>
                                                </div>
                                                <div className="field input-field">
                                                    <input
                                                        type={
                                                            showConfirmPassword
                                                                ? "text"
                                                                : "password"
                                                        }
                                                        placeholder={t(
                                                            "Confirm_password",
                                                        )}
                                                        className={`password ${
                                                            confirmPasswordError
                                                                ? "is-invalid"
                                                                : ""
                                                        }`}
                                                        name="confirmPassword"
                                                        value={
                                                            formData.confirmPassword
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                    <i
                                                        className={`bx ${
                                                            showConfirmPassword
                                                                ? "bx-show"
                                                                : "bx-hide"
                                                        } eye-icon`}
                                                        onClick={
                                                            toggleConfirmPasswordVisibility
                                                        }
                                                    ></i>
                                                </div>
                                                <div className="field button-field">
                                                    <button
                                                        type="button"
                                                        onClick={handleSubmit} // Відкриваємо друге модальне вікно
                                                    >
                                                        {t("Sign_up")}
                                                    </button>
                                                </div>
                                            </form>
                                            <div className="form-link">
                                                <span>
                                                    {t(
                                                        "Already_have_an_account",
                                                    )}{" "}
                                                    <a
                                                        href="#"
                                                        className="link login-link"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleLoginClick(); // Викликаємо функцію відкриття модального вікна входу
                                                        }}
                                                    >
                                                        {t("Login")}
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Затемнення фону для першого модального вікна */}
            {visible && (
                <div
                    className={`modal-backdrop fade ${animate ? "show" : ""}`}
                    onClick={closeFirstModal}
                ></div>
            )}

            {/* Друге модальне вікно */}
            <Suspense fallback={<div>{t("Login")}...</div>}>
                {showCompleteModal && (
                    <>
                        <div
                            className={`modal fade registration_modal ${
                                showCompleteModal ? "show" : ""
                            }`}
                            id="complete_registration_modal"
                            tabIndex="-1"
                            style={{ display: "block" }}
                            aria-modal="true"
                            role="dialog"
                        >
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3>
                                            <img
                                                src="/assets/img/logo-mobile.png"
                                                alt="Nome-sito"
                                            />{" "}
                                            {t("Complete_your_registration")}
                                        </h3>
                                        <button
                                            className="btn-close"
                                            onClick={closeCompleteModal}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        {/* Вміст другого модального вікна */}
                                        <CompleteRegistrationModal
                                            setIsLogged={setIsLogged}
                                            show={showCompleteModal}
                                            handleClose={closeCompleteModal}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Затемнення фону для другого модального вікна */}
                        <div
                            className={`modal-backdrop fade ${
                                showCompleteModal ? "show" : ""
                            }`}
                            onClick={closeCompleteModal}
                        ></div>
                    </>
                )}
            </Suspense>
        </>
    );
}

export default ModalRegister;
